import '@vfde-brix/ribbon-badge/dist/styles.css';
import { createRibbonBadge } from '@vfde-brix/ribbon-badge';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-ribbon-badge', createRibbonBadge, NO_PATTERN_BUSINESS_LOGIC);
